import { ProductType } from '@/types/product';
import { AddPopup, ShippingThresholdInfo, TagInfo } from '@/types/so';
import React, { createContext, useContext, useEffect, useReducer } from 'react';
import {
  SyncShippingThresholdInfo,
  addCart,
  addMultiple,
  setReferrer,
  setReferrerType,
  subCart,
  syncActivedVendor,
  syncAddPopup,
  syncAllCartData,
  syncCartInfo,
  syncSellerCartInfo,
  syncSellerCartsInfo,
  syncSimpleCartInfo,
  syncTagInfo,
  syncYouMayLike,
  updateSimpleCart,
  syncSimpleItems
} from './actions';
import reducers, { initState } from './reducers';

const MyContext = createContext<{ [key: string]: any }>(initState);

type DataType = {
  count?: number;
  tagInfo?: TagInfo;
  ymlInfo?: ProductType[];
  ymlId?: number;
  sellerTagInfo?: AddPopup;
  [key: string]: any;
  shippingThresholdInfo?: ShippingThresholdInfo;
  sellerCartInfo?: any;
  allCartInfo?: any;
};

type Props = {
  data?: DataType;
  children: React.ReactNode | string | React.ReactNode[];
};

export const ShoppingProvider = ({ children, data }: Props) => {
  const [dataState, dispatch] = useReducer(reducers, data || initState);
  return <MyContext.Provider value={{ ...dataState, dispatch }}>{children}</MyContext.Provider>;
};

export default function useContextState(): DataType {
  const { dispatch, ...store } = useContext(MyContext);
  return {
    ...store,
    handleSyncSimpleCart: info => {
      dispatch(syncSimpleCartInfo(info));
    },
    handleSyncCartInfo: info => {
      dispatch(syncCartInfo(info));
    },
    handleUpdateSimple: info => {
      dispatch(updateSimpleCart(info));
    },
    addGoodsInCart: info => {
      dispatch(addCart(info));
    },
    subGoodsInCart: info => {
      dispatch(subCart(info));
    },
    handleSyncTagInfo: (info: TagInfo) => {
      dispatch(syncTagInfo(info));
    },
    handleSyncYouMayLike: (ymlInfo: ProductType[], ymlId: number) => {
      dispatch(syncYouMayLike(ymlInfo, ymlId));
    },
    doSetReferrer: info => {
      dispatch(setReferrer(info));
    },
    addMultiple: info => {
      dispatch(addMultiple(info));
    },
    doSetReferrerType: info => {
      dispatch(setReferrerType(info));
    },
    handleSyncAddPopup: (info: AddPopup) => {
      dispatch(syncAddPopup(info));
    },
    handleSyncAllCartData: (info: DataType) => {
      dispatch(syncAllCartData(info));
    },
    handleSyncShippingThresholdInfo: (info: ShippingThresholdInfo) => {
      dispatch(SyncShippingThresholdInfo(info));
    },
    handleSyncSellerCartInfo: info => {
      dispatch(syncSellerCartInfo(info));
    },
    handleSyncSellerCartsInfo: info => {
      dispatch(syncSellerCartsInfo(info));
    },
    //添加 修改（不包括删除商家）数量变化的时候要滚动到修改的商家到可视范围内
    handleActivedVendor: venderId => {
      dispatch(syncActivedVendor(venderId));
    },
    handleSyncSimpleItems: info => {
      dispatch(syncSimpleItems(info));
    }
  };
}
